import React, { useEffect, useState } from 'react'
import LayoutProvider from '../../../../providers/LayoutProvider';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { useAppDispatch, useAppSelector } from '../../../../hooks/app';
import { getInvitations, getInvitationsFromApi, getInvitationsTotalCount } from '../../../../store/slices/invitation.slice';
import { getUser } from '../../../../store/slices/auth-slice';
import InvitationService from '../../../../services/invitation.service';
import { getUserApiStatus, setStatusForStudentInstructor } from '../../../../store/slices/instructor-student.slice';
import { API_STATUS } from '../../../../constants';
import SpinnerLoader from '../../../../components/SpinnerLoader';
import useCustomToast from '../../../../hooks/useCustomToast';
import { confirmAlert } from 'react-confirm-alert';
import { Toaster } from 'react-hot-toast';

function Invitations() {

  const user = useAppSelector(getUser)
  const totalCount = useAppSelector(getInvitationsTotalCount)
  const data = useAppSelector(getInvitations)
  const dispatch = useAppDispatch()
  const loading = useAppSelector(getUserApiStatus)
  const customToast = useCustomToast()

  const [perPage, setPerPage] = useState(10)
  const [page, setPage] = useState(1)


  const handlePerRowsChange = async (newPerPage: number) => {
    setPerPage(newPerPage)
  }
  const handlePageChange = (page: number) => {
    setPage(page)
  }
  useEffect(() => {
    dispatch(getInvitationsFromApi({ page, per_page: perPage }))
  }, [dispatch, page, perPage])

  const removeInvitation = async (id: string) => {
    confirmAlert({
      title: 'Confirm',
      message: `Are you sure you want to remove this invitation?`,
      buttons: [
        {
          label: 'Yes',
          onClick: async () => {
            dispatch(setStatusForStudentInstructor(API_STATUS.LOADING))
            const res: any = await InvitationService.remove(id)
            if (res?.status === 200) {
              customToast(res?.message, "success")
              dispatch(getInvitationsFromApi())
            }
            dispatch(setStatusForStudentInstructor(API_STATUS.SUCCEEDED))
          },
        },
        {
          label: 'No',
          onClick: () => { },
        },
      ],
    })
  }


  const updateInvitationStatus = async (id: string, status: string | number) => {
    confirmAlert({
      title: 'Confirm',
      message: `Are you sure you want to ${status == 1 ? "approve" : "cancel"} this invitation?`,
      buttons: [
        {
          label: 'Yes',
          onClick: async () => {
            dispatch(setStatusForStudentInstructor(API_STATUS.LOADING))
            const res: any = await InvitationService.updateStatus(id, status)
            if (res?.status === 200) {
              customToast(res?.message, "success")
              dispatch(getInvitationsFromApi())
            }
            dispatch(setStatusForStudentInstructor(API_STATUS.SUCCEEDED))
          },
        },
        {
          label: 'No',
          onClick: () => { },
        },
      ],
    })
  }

  const columns = [
    {
      name: "Invitation ID",
      cell: (row: any) => row?._id?.substring(0, 15),
      wrap: false,
      grow: 1
    },
    {
      name: "Invitation From",
      cell: (row: any) => row?.from?._id === user?._id ? `${row?.from?.firstname || ""} ${row?.from?.lastname || ""} (You)` : `${row?.from?.firstname || ""} ${row?.from?.lastname || ""}`,
      grow: 1
    },
    {
      name: "Invitation To",
      cell: (row: any) => row?.to ? `${row?.to?.firstname || ""} ${row?.to?.lastname || ""} ${row?.to?._id === user?._id || row?.toEmail === user?.email ? '(You)' : ''}` : row?.toEmail,
      grow: 1
    },
    {
      name: "Invitation Date",
      cell: (row: any) => moment(row?.createdAt).format("MM/DD/YYYY HH:mm:ss"),
    },
    {
      name: "Expiry Date",
      cell: (row: any) => moment(row?.expire).format("MM/DD/YYYY HH:mm:ss"),
    },
    {
      name: "Status",
      cell: (row: any) => {
        if (row.status === 0) {
          return <h4 className="badge p-2 bg-warning">Pending</h4>;
        }
        if (row.status === 1) {
          return <h4 className="badge p-2 bg-success">Approved</h4>;
        }
        if (row.status === 2) {
          return <h4 className="badge p-2 bg-danger">Cancelled</h4>;
        }
        if (row.status === 3) {
          return <h4 className="badge p-2 bg-secondary">Expired</h4>;
        }
      },
    },
    {
      name: "Action",
      grow: 1,
      cell: (row: any) => {
        return <div className='d-flex align-items-center gap-1 '>
          {
            row?.from?._id === user?._id || row?.status == 1 || row?.status == 2 || row?.status == 3 ? null : <>
              <Link to="#" className="btn btn-primary btn-sm d-block" style={{ wordBreak: "keep-all" }} onClick={() => updateInvitationStatus(row?._id, 1)}>Approve</Link>
              <Link to="#" className="btn btn-warning btn-sm d-block" style={{ wordBreak: "keep-all" }} onClick={() => updateInvitationStatus(row?._id, 2)}>Cancel</Link>
            </>
          }
          {row?.from?._id === user?._id ? <button className="btn btn-danger btn-sm d-block" style={{ wordBreak: "keep-all" }} onClick={() => removeInvitation(row?._id)}>{row?.status == 0 ? "Withdraw Request" : "Remove From List"}</button> : null}
        </div>
      }
    },

    // {
    //   name: "Status",
    //   cell: (row: any) => {
    //     return (
    //       <div className="d-flex align-items-center gap-4 justify-content-between">
    //         <Link to="#">
    //           <FiEdit
    //             className="text-info "
    //             style={{
    //               cursor: "pointer",
    //               fontSize: "1.2em",
    //               fontWeight: 600,
    //             }}
    //           />
    //         </Link>
    //         <FiTrash2
    //           className="2 text-danger "
    //           style={{ cursor: "pointer", fontSize: "1.2em", fontWeight: 600 }}
    //         />
    //       </div>
    //     );
    //   },
    // },
  ];
  const paginationComponentOptions = {
    rowsPerPageText: "Rows Per Page",
    rangeSeparatorText: "of",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Requests",
    styles: {
      background: "red",
    },
  };

  return (
    <LayoutProvider>
      <Toaster />
      {loading === API_STATUS.LOADING && <SpinnerLoader />}
      <div className="my-3">
        <h2 className="heading2">New Invitations</h2>
      </div>
      <div className="invitations_page">
        <DataTable
          columns={columns}
          data={data || []}
          pagination
          paginationServer
          paginationTotalRows={totalCount}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          paginationComponentOptions={paginationComponentOptions}
          customStyles={{
            rows: {
              style: {
                minHeight: "60px",
                "&:nth-child(odd)": {
                  background: "#EFF6FF",
                },
              },
            },
            headCells: {
              style: {
                fontSize: "14px",
                fontWeight: "bold",
              },
            },
            cells: {
              style: {
                fontSize: "14px",
              },
            },
          }}
        />
      </div>

    </LayoutProvider>
  )
}

export default Invitations